module.exports = __webpack_public_path__ + "img/thumbnail_CommonDeathAdder_u_albino.c0c10dfb.png";